import Framework, { shapes } from '@greenville/framework';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import { ThemeProvider, createTheme, withStyles } from '@material-ui/core/styles';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ChatgptConfig from '../../../../common/config/ChatgptConfig';
import * as constants from '../../../../common/constants';
// import env from '../../../../common/env';
import UserId from '../../../users/models/UserId';
import TenantConfigModel from '../../models/TenantConfig';
import GetBookTitlesDataModel from '../../models/GetBookTitles';
// import UserPermissionCheck from '../../models/UserPermissionCheck';

const styles = () => ({
  headingClass: {
    padding: '15px',
    fontWeight: 'bold'
  },
  selectTenant: {
    justifyContent: 'center',
    alignItems: 'baseline'
  },
  buttonGroupStyle: {
    justifyContent: 'center'
  },
  buttonStyle: {
    width: '120px',
    margin: '10px'
  }
});

const themes = createTheme({
  palette: {
    primary: {
      light: '#047a9c',
      main: '#005d83',
      dark: '#003558',
      contrastText: '#ffffff'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 30
      }
    }
  }
});

const TenantList = (props) => {
  const history = useHistory();
  const { classes, tenantConfig, bookTitles, handleTenantName } = props;
  const [tenantName, setTenantName] = useState('');
  const [isTenantRequired, setTenantRequired] = useState(false);
  // const [tenantId, setTenantId] = useState(null);
  const [tenantItems, setTenantItems] = useState([]);

  const setTenantsListItems = (dataArr) => {
    const result = dataArr.map((items) => {
      const match = ChatgptConfig.tenantData.find((config) => config.name === items.name);
      if (match) {
        return {
          ...items,
          tabDetails: match.tabDetails || [],
          titles: match.titles || []
        };
      }

      return items;
    });
    setTenantItems(result);
  };

  useEffect(() => {
    const { data } = toJS(tenantConfig);
    if (data.length > 0) {
      setTenantsListItems(data);
    }
  }, []);

  useEffect(() => {
    Framework.getEventManager().on(constants.SET_TENANT_CONFIG_DATA, () => {
      const { data } = toJS(tenantConfig);
      if (data.length > 0) {
        setTenantsListItems(data);
      }
    });
    bookTitles.resetStoreValues();
  }, [tenantConfig]);

  const setPermissionFlag = (name) => {
    const tenantData = tenantItems.find((data) => data.name === name);
    const {
      userid: {
        userdetails: { tenantId }
      }
    } = props;
    if (tenantData?.tenantId && props?.userid?.userdetails?.tenantId) {
      const tenantIds = tenantId.split(',');
      if (tenantIds.includes(tenantData.tenantId)) {
        Framework.getStoreRegistry().getStore('userPermissionCheck').set({ isPermissionCheck: true });
      } else {
        Framework.getStoreRegistry().getStore('userPermissionCheck').set({ isPermissionCheck: false });
      }
    } else {
      Framework.getStoreRegistry().getStore('userPermissionCheck').set({ isPermissionCheck: true });
    }
  };

  const handleChange = (event) => {
    setTenantName(event.target.value);
    setPermissionFlag(event.target.value);
    handleTenantName(event.target.value);
  };
  const handleSearch = () => {
    if (tenantName === 'aistudytools') {
      history.push('/chatgptutility/aistudytools');
    } else if (tenantName === 'channels') {
      history.push('/chatgptutility/channels');
    } else {
      tenantItems?.forEach((item) => {
        if (tenantName === item.name) {
          history.push(`/chatgptutility/${item.name}/auditlog`);
        }
      });
    }
  };
  const handleReset = () => {
    setTenantRequired(false);
    setTenantName('');
  };

  return (
    <>
      <Paper>
        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ p: 3 }}>
            <Typography variant="h5" align="center" gutterBottom spacing={9}>
              {constants.TENANT_LIST_TEXT}
            </Typography>
          </Box>
          <Box>
            <Grid container direction="row" alignItems="center" className={classes.selectTenant}>
              <Typography className={classes.headingClass}>{constants.SELECT_PRODUCT_LABEL}</Typography>
              <FormControl sx={{ minWidth: '32%', maxWidth: '90%' }} size="small">
                <InputLabel id="tenantLabelId">{constants.SELECT_PRODUCT_LABEL}</InputLabel>
                <Select label="Select Tenant" name="tenantId" value={tenantName} onChange={handleChange}>
                  <MenuItem disabled value="">
                    <em>{constants.SELECT_PLACEHOLDER_TENANT}</em>
                  </MenuItem>
                  {tenantItems && tenantItems.map((item) => <MenuItem value={item.name}>{item.title}</MenuItem>)}
                </Select>
                {isTenantRequired && <FormHelperText style={{ color: 'red' }}>Please Select Tenant</FormHelperText>}
              </FormControl>
            </Grid>
          </Box>
          <Box sx={{ p: 7 }}>
            <Grid container className={classes.buttonGroupStyle}>
              <ThemeProvider theme={themes}>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleSearch}
                  className={classes.buttonStyle}
                  disabled={tenantName === ''}
                >
                  {constants.TENANT_SEARCH_BUTTON}
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleReset}
                  className={classes.buttonStyle}
                >
                  {constants.CHAT_RESET}
                </Button>
              </ThemeProvider>
            </Grid>
            <br />
          </Box>
        </Box>
      </Paper>
    </>
  );
};

TenantList.propTypes = {
  classes: PropTypes.object.isRequired,
  // resetTab: PropTypes.func.isRequired,
  userid: shapes.modelOf(UserId).isRequired,
  // userPermissionCheck: shapes.modelOf(UserPermissionCheck).isRequired,
  tenantConfig: shapes.modelOf(TenantConfigModel).isRequired,
  bookTitles: shapes.modelOf(GetBookTitlesDataModel).isRequired,
  handleTenantName: PropTypes.func.isRequired
};

export default withStyles(styles)(
  observer(inject('chatgptAdmin', 'userid', 'tenantConfig', 'bookTitles', 'userPermissionCheck')(TenantList))
);
